import { Navbar, Container } from 'react-bootstrap';
import { Link } from 'react-router-dom';

function NavBar() {
    return (
        <Navbar bg="dark" variant="dark">
            <Container>
                <Navbar.Brand as={Link} to="/">
                    <h5 className='nav-text'>Rajamangala University Of Technology Isan</h5>
                    <h1 className='nav-text-title'>RMUTI API SERVICE</h1>
                </Navbar.Brand>
            </Container>
        </Navbar>
    )
}

export default NavBar;